import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../components/ui/Logo';
import Button from '../components/ui/Button';

function OnboardingSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [storeNames, setStoreNames] = useState([]);
  
  const storesCount = searchParams.get('stores');
  const email = searchParams.get('email');
  const names = searchParams.get('names');
  
  useEffect(() => {
    if (names) {
      setStoreNames(names.split(','));
    }
  }, [names]);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-orange-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex items-center justify-center py-12 px-4">
      <div className="max-w-2xl w-full">
        <div className="surface-card rounded-2xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
          <div className="bg-gradient-to-r from-emerald-600 to-orange-600 px-8 py-8 text-center">
            <Logo className="justify-center mb-4" size="lg" />
            <div className="text-5xl mb-4" aria-hidden>✅</div>
            <h1 className="text-3xl font-bold text-white">
              Stores connected successfully
            </h1>
            <p className="mt-2 text-emerald-100 text-sm">
              Your Amazon stores have been discovered and connected
            </p>
          </div>
          
          <div className="px-8 py-8 space-y-6">
            <div className="bg-emerald-50/80 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-800 rounded-xl p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-600 dark:text-slate-400">Stores discovered</p>
                  <p className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">{storesCount || 0}</p>
                </div>
                <div className="text-4xl" aria-hidden>📦</div>
              </div>
            </div>
            
            {storeNames.length > 0 && (
              <div>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-3">Connected stores</h3>
                <div className="space-y-2">
                  {storeNames.map((name, index) => (
                    <div key={index} className="flex items-center p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700">
                      <div className="flex-shrink-0 w-8 h-8 bg-emerald-100 dark:bg-emerald-950/50 rounded-full flex items-center justify-center">
                        <span className="text-emerald-700 dark:text-emerald-300 font-bold text-sm">{index + 1}</span>
                      </div>
                      <p className="ml-3 text-slate-800 dark:text-slate-200 font-medium">{name}</p>
                      <div className="ml-auto text-emerald-500">✓</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {email && (
              <div className="p-4 bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800 rounded-lg">
                <p className="text-sm text-orange-900 dark:text-orange-100">
                  <strong>Account email:</strong> {email}
                </p>
              </div>
            )}
            
            <div className="p-6 bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-700 rounded-xl">
              <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-3">Next steps</h3>
              <ol className="space-y-2 text-sm text-slate-700 dark:text-slate-300 list-decimal list-inside">
                <li>Our team will review and approve your store access</li>
                <li>You will receive an email when your account is ready</li>
                <li>Log in with Amazon to start managing campaigns</li>
              </ol>
            </div>

            <Button variant="primary" className="w-full" size="xl" onClick={() => navigate('/login')}>
              Go to login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingSuccess;
